const Immutable = require('immutable')
const { keyedReviver } = require('client-v2/common/state/record-reviver')

class AuthModalRecord extends Immutable.Record({
  errorProvider: String(),
  errorType: String(),
  hasAccount: Boolean(),
  isSULandingPage: Boolean(),
  isVisible: Boolean()
}) {
  hide() {
    return this.merge({
      errorProvider: null,
      errorType: null,
      isVisible: false
    })
  }

  show({ hasAccount }) {
    return this.merge({
      hasAccount,
      isVisible: true
    })
  }
}

AuthModalRecord.reviver = keyedReviver(AuthModalRecord, {
  // No nested data structures
})

module.exports = AuthModalRecord
